'use strict';

require('./salary-intro.scss');

module.exports = {
  template: require('./salary-intro.html'),
  controller: require('./salary-intro.controller'),
  controllerAs: 'vm',

  bindings: {
    data: '<',
    me: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/salary/salary-intro/index.js
 ** module id = 207
 ** module chunks = 0
 **/